import React from "react";
import { Input, Row, Col, Label, CustomInput } from "reactstrap";
import "./styles.css";
import {
  Button,
  Form,
  Drawer,
  Spin,
  Popconfirm,
  Table,
  Select,
  Progress,
  message,
} from "antd";
import { storage } from "../../../firebase";
import TopicDrawer from "./topicDrawer.js";
import { DeleteOutlined, CloseOutlined } from "@ant-design/icons";
import { Editor } from "@tinymce/tinymce-react";
import XslxGen from "../xslx";

const { Option } = Select;
const key = "updatable";

export default class MedTable extends React.Component {
  state = {
    loader: false,
    searchField: "",
    visible: false,
    topicDrawer: false,
    courses: [],
    courseThumbnailImage: "",
    courseThumbnailImageProgress: 0,
    errors: {},
    fireBaseTransfer: false,
    titleEntered: false,
    editMode: false,
    topicEditMode: false,
    editableTopic: [],
    columns: [
      {
        title: "#",
        dataIndex: "rowNumber",
        width: "10%",
        key: "id",
        align: "center",
      },
      {
        title: "Title",
        width: "18%",
        key: "Name",
        render: (record) => (
          <p
            className="grow titleText no-underline underline-hover"
            style={{ cursor: "pointer" }}
            onClick={() => this.editCourse(record)}
          >
            <b>{record.courseTitle}</b>
          </p>
        ),
      },
      {
        title: "Domain",
        dataIndex: "domain",
        width: "13%",
        key: "Domain",
      },
      {
        title: "Short Description",
        dataIndex: "courseShortDesc",
        width: "20%",
        key: "courseShortDesc",
      },
    ],
    //Course Data to be posted
    courseId: "",
    courseTitle: "",
    domain: "Voice",
    courseShortDesc: "",
    courseDesc: "<p>Empty</p>",
    courseThumbnailImageUrl: "",
    createdBy: "",
    courseMinutes: 0,
    courseTopics: [],
  };

  handleFiles = (e) => {
    if (e.target.files[0]) {
      this.setState({ courseThumbnailImage: e.target.files[0] }, () => {
        this.handelUpload();
      });
    }
  };

  handelUpload = () => {
    const { courseThumbnailImage, courseTitle } = this.state;
    this.setState({ fireBaseTransfer: true });
    const uploadScreenshot = storage
      .ref(`lte/CourseThumbnails/${courseTitle}`)
      .put(courseThumbnailImage);

    uploadScreenshot.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        this.setState({ courseThumbnailImageProgress: progress });
      },
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref("lte/CourseThumbnails")
          .child(courseTitle)
          .getDownloadURL()
          .then((url) => {
            this.setState({
              courseThumbnailImageUrl: url,
              fireBaseTransfer: false,
            });
          });
      }
    );
  };

  componentDidMount = () => {
    this.setState({ loader: false });
    fetch(
      "https://sbhs-web-server.herokuapp.com/lte/course/all"
      // "http://localhost:4000/lte/course/all"
    )
      .then((response) => response.json())
      .then((response) => {
        if (response) {
          const results = response.map((row, index) => ({
            _id: row._id,
            key: row._id,
            rowNumber: index + 1,
            courseTitle: row.courseTitle,
            domain: row.domain,
            courseShortDesc: row.courseShortDesc,
            courseDesc: row.courseDesc,
            courseTopics: row.courseTopics,
            courseThumbnailImageUrl: row.courseThumbnailImageUrl,
            createdBy: row.createdBy,
            courseMinutes: row.courseMinutes,
            createdDate: row.createdDate,
          }));
          this.setState({ courses: results, loader: true });
        }
      });
  };

  onSubmitUpdate = () => {
    // console.log(this.state.courseId);
    // console.log(this.state.courseTitle);
    message.loading({ content: "Updating Course...", key });
    fetch(
      "https://sbhs-web-server.herokuapp.com/lte/course/edit",
      // "http://localhost:4000/lte/course/edit",
      {
        method: "put",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          courseId: this.state.courseId,
          domain: this.state.domain,
          courseTitle: this.state.courseTitle,
          courseShortDesc: this.state.courseShortDesc,
          courseDesc: this.state.courseDesc,
          courseThumbnailImageUrl: this.state.courseThumbnailImageUrl,
          courseMinutes: this.state.courseMinutes,
          courseTopics: this.state.courseTopics,
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        // console.log("submit response ", response);
        if (response && !response._id) {
          this.setState({
            errors: response,
          });
        } else {
          setTimeout(() => {
            message.success({
              content: "Course Updated Successfully!",
              key,
              duration: 2,
            });
          }, 1000);
          this.onClose();
          this.componentDidMount();
        }
      });
  };

  handleSearchChange = (event) => {
    this.setState({ searchField: event.target.value });
  };

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    document.getElementById("create-user-form").reset();
    this.setState({
      fireBaseTransfer: false,
      searchField: "",
      visible: false,
      courseThumbnailImage: "",
      courseThumbnailImageProgress: 0,
      titleEntered: false,
      editMode: false,
      //Data to be posted
      courseMinutes: 0,
      courseTitle: "",
      courseShortDesc: "",
      courseDesc: "<p>Empty</p>",
      courseThumbnailImageUrl: "",
      createdBy: "",
      courseTopics: [],
    });
  };

  onChange = (e) => {
    if (e.target.name === "courseTitle") {
      this.setState({
        [e.target.name]: e.target.value,
        titleEntered: true,
      });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  handleEditorChange = (e) => {
    // console.log(e.target.getContent());
    this.setState({ courseDesc: e.target.getContent() });
  };

  handleDomainSelected = (value) => {
    this.setState({ domain: value });
  };

  onSubmit = () => {
    message.loading({ content: "Submitting Course...", key });
    fetch(
      "https://sbhs-web-server.herokuapp.com/lte/course/register",
      // "http://localhost:4000/lte/course/register",
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          courseMinutes: this.state.courseMinutes,
          courseTitle: this.state.courseTitle,
          domain: this.state.domain,
          createdBy: this.state.createdBy,
          courseShortDesc: this.state.courseShortDesc,
          courseDesc: this.state.courseDesc,
          courseTopics: this.state.courseTopics,
          courseThumbnailImageUrl: this.state.courseThumbnailImageUrl,
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        if (response && !response._id) {
          this.setState({
            errors: response,
          });
          setTimeout(() => {
            message.info({
              content: "Fill out Required Fields",
              key,
              duration: 2,
            });
          }, 1000);
        } else if (response._id) {
          setTimeout(() => {
            message.success({
              content: "Course Submitted Successfully!",
              key,
              duration: 2,
            });
          }, 1000);
          this.onClose();
          this.componentDidMount();
        } else {
          setTimeout(() => {
            message.warning({
              content: "Course Submission Failed!",
              key,
              duration: 2,
            });
          }, 1000);
        }
      });
  };

  editSelectedTopic = (topic) => {
    this.setState(
      {
        editableTopic: topic,
        topicDrawer: true,
        topicEditMode: true,
      },
      () => {
        // console.log(this.state.editableTopic);
      }
    );
  };

  editCourse = (course) => {
    // console.log(course.courseDesc);
    this.setState({
      courseId: course._id,
      courseTitle: course.courseTitle,
      domain: course.domain,
      courseShortDesc: course.courseShortDesc,
      courseDesc: course.courseDesc,
      courseMinutes: course.courseMinutes,
      courseTopics: course.courseTopics,
      courseThumbnailImageUrl: course.courseThumbnailImageUrl,
      visible: true,
      editMode: true,
    });
  };

  deleteCourse = (id) => {
    message.loading({ content: "Deleting Course...", key });
    fetch(
      `https://sbhs-web-server.herokuapp.com/lte/course/delete?_id=${id}`,
      // `http://localhost:4000/lte/course/delete?_id=${id}`,
      {
        method: "delete",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((response) => {
        // console.log("submit response ", response.success);
        if (response.success === true) {
          setTimeout(() => {
            message.success({
              content: "Course Deleted Successfully!",
              key,
              duration: 2,
            });
          }, 1000);
          this.onClose();
          this.componentDidMount();
        } else {
          setTimeout(() => {
            message.warning({
              content: "Course Deletion Failed!",
              key,
              duration: 2,
            });
          }, 1000);
        }
      });
  };

  deleteTopic = (index) => {
    this.state.courseTopics.splice(index, 1);
    this.setState({ courseTopics: this.state.courseTopics });
    // console.log(this.state.courseTopics);
  };

  saveTopic = (topic) => {
    const temp = this.state.courseTopics;
    temp.push({
      topicTitle: topic.topicTitle,
      topicDetail: topic.topicDetail,
      video: topic.topicVideoUrl,
      pdf: topic.topicPdfUrl,
      audio: topic.topicAudioUrl,
      quiz: topic.quiz,
      topicThumbnailImageUrl: topic.topicThumbnailImageUrl,
    });
    this.setState({
      courseTopics: temp,
    });
    console.log(this.state);
  };

  editTopic = (editedTopic) => {
    console.log("Updated Course ", editedTopic);
  };

  showTopicDrawer = () => {
    this.setState({
      topicDrawer: true,
    });
  };

  render() {
    const {
      courses,
      searchField,
      editMode,
      errors,
      loader,
      editSelectedTopic,
    } = this.state;
    const filteredCourses = courses.filter((course) => {
      return course.courseTitle
        .toLowerCase()
        .includes(searchField.toLowerCase());
    });
    return (
      <div className="MesdTable">
        {!loader ? (
          <div>
            <div className="loadingText"></div>
            <div className="tc f19 lh-copy">
              <Spin />
            </div>
          </div>
        ) : (
          <div>
            <TopicDrawer
              topicDrawer={this.state.topicDrawer}
              editSelectedTopic={this.state.editableTopic}
            />
            <Row
              style={{
                marginRight: "20px",
              }}
            >
              <Col md="2">
                <Button className="userButton" onClick={this.showDrawer}>
                  {"Add New Course"}
                </Button>
              </Col>
              <Col md="2">
                <XslxGen csvData={filteredCourses} fileName={"All Courses"} />
              </Col>
              <Col md="4" />
              <Col md="4">
                <Input
                  className="input"
                  placeholder="Search by Title.."
                  onChange={this.handleSearchChange}
                  type="search"
                />
              </Col>
            </Row>

            <div className="TableScrollbar">
              <Table
                bordered
                dataSource={filteredCourses}
                columns={this.state.columns}
                scroll={{ y: 620 }}
                pagination={false}
              />
            </div>
          </div>
        )}

        <Drawer
          title="Add New Course"
          width={window.innerWidth > 600 ? 740 : window.innerWidth - 150}
          onClose={this.onClose}
          visible={this.state.visible}
          style={{ backgroundColor: "#0000008a" }}
          footer={
            <Row gutter={24}>
              <Col span={8}>
                <Button
                  className="mButton"
                  style={{ marginRight: 8 }}
                  disabled={this.state.fireBaseTransfer}
                  onClick={() => {
                    editMode ? this.onSubmitUpdate() : this.onSubmit();
                  }}
                  type="primary"
                >
                  {editMode ? "Update" : "Submit"}
                </Button>
              </Col>
              <Col span={8}>
                {/* <TopicDrawer
                  onSubmit={this.saveTopic}
                  onEdit={this.editTopic}
                /> */}
                <Button
                  className="mButton"
                  onClick={() => {
                    this.showTopicDrawer();
                  }}
                >
                  Add Topic
                </Button>
              </Col>
              <Col span={8}>
                {editMode ? (
                  <div
                    style={{
                      textAlign: "right",
                    }}
                  >
                    <Popconfirm
                      placement="right"
                      title="Delete this Course ？"
                      okText="Yes"
                      cancelText="No"
                      onConfirm={() => {
                        this.deleteCourse(this.state.courseId);
                      }}
                    >
                      <DeleteOutlined
                        type="Delete Course"
                        title="Delete Course"
                        style={{ fontSize: "40px", color: "#d0672e" }}
                        theme="outlined"
                      />
                    </Popconfirm>
                  </div>
                ) : null}
              </Col>
            </Row>
          }
        >
          <Form id="create-user-form" layout="vertical" hideRequiredMark>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label="Title"
                  rules={[
                    {
                      required: true,
                      message: errors.courseTitle,
                    },
                  ]}
                >
                  <Input
                    name="courseTitle"
                    value={this.state.courseTitle}
                    error={errors.courseTitle}
                    onChange={this.onChange}
                    placeholder="Enter Course Title"
                  />
                  <Label className="red">{errors.courseTitle}</Label>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="Domain"
                  rules={[
                    {
                      required: true,
                      message: errors.domain,
                    },
                  ]}
                >
                  <Select
                    defaultValue="Se"
                    allowClear
                    value={this.state.domain}
                    // error={errors.domain}
                    onChange={this.handleDomainSelected}
                  >
                    <Option value="Voice">Voice</Option>
                    <Option value="Soundboard">Soundboard</Option>
                    <Option value="Closers">Closers</Option>
                  </Select>
                  <Label className="red">{errors.domain}</Label>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="Course Minutes"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input
                    name="courseMinutes"
                    value={this.state.courseMinutes}
                    type="number"
                    onChange={this.onChange}
                    placeholder="Enter Course Minutes"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label="Short Description"
                  rules={[
                    {
                      required: true,
                      message: "Please write short description",
                    },
                  ]}
                >
                  <Input
                    value={this.state.courseShortDesc}
                    name="courseShortDesc"
                    onChange={this.onChange}
                    placeholder="Write Something . . ."
                  />
                  <Label className="red">{errors.courseShortDesc}</Label>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Course Thumbnail Image"
                  rules={[
                    {
                      required: true,
                      message: "Please write Detailed description",
                    },
                  ]}
                >
                  <CustomInput
                    disabled={!this.state.titleEntered}
                    type="file"
                    accept="image/*"
                    id="exampleCustomFileBrowser"
                    name="customFile"
                    label="Upload a Thumbnail"
                    onChange={this.handleFiles}
                  >
                    <Progress
                      percent={this.state.courseThumbnailImageProgress}
                    />
                  </CustomInput>
                  <Label className="red">
                    {errors.courseThumbnailImageUrl}
                  </Label>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={24}>
                <Editor
                  initialValue={this.state.courseDesc}
                  apiKey="ghrpxealk6vlmuwhx63cv17ffqlsamcu8hjnccyjhtvjkdsb"
                  init={{
                    height: 250,
                    menubar: true,
                    plugins: [
                      "advlist autolink lists link image",
                      "charmap print preview anchor help",
                      "searchreplace visualblocks code",
                      "insertdatetime media table paste wordcount",
                    ],
                    toolbar:
                      // eslint-disable-next-line
                      "undo redo | formatselect | bold italic | \
            alignleft aligncenter alignright | \
            bullist numlist outdent indent | help",
                  }}
                  onChange={this.handleEditorChange}
                />
              </Col>
              <Label className="red">{errors.courseDesc}</Label>
            </Row>
            <br />
            <Row gutter={24}>
              <Col span={24}>
                <Form.Item
                  label={"Course Topics : " + this.state.courseTopics.length}
                >
                  <div className="scrollableDiv2 tc">
                    {this.state.courseTopics.map((item, key) => {
                      return (
                        <Row className="grow">
                          <h6
                            className="topicTab"
                            onClick={() => {
                              this.editSelectedTopic(item);
                            }}
                          >
                            {key + 1 + " | " + item.topicTitle}
                          </h6>
                          <Popconfirm
                            placement="right"
                            title="Remove this Topic ？"
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => {
                              this.deleteTopic(key);
                            }}
                          >
                            <CloseOutlined
                              type="Delete Topic"
                              title="Delete Topic"
                              style={{ fontSize: "23px", color: "red" }}
                              theme="outlined"
                            />
                          </Popconfirm>
                        </Row>
                      );
                    })}
                  </div>
                  <Label className="red">{errors.courseTopics}</Label>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </div>
    );
  }
}
